import { encode } from "../helper/encode";
import { trackEvents } from "./trackEvents";
import { TRACKING_EVENT_NAME } from "./tracking.service";

export function sendCategoryViewEvent(query: any, eventName = TRACKING_EVENT_NAME.CATEGORY_PAGE_VIEW) {
  const cleanQueryObj = { ...query };
  if (cleanQueryObj.tier0) {
    cleanQueryObj.tier0 = encode(cleanQueryObj.tier0, "(_|-)", " ");
  }
  Object.keys(cleanQueryObj).forEach((key) => {
    if (cleanQueryObj[key] === undefined) {
      delete cleanQueryObj[key];
    } else if (typeof cleanQueryObj[key] === "string") {
      cleanQueryObj[key] = cleanQueryObj[key].toLowerCase().trim();
    } else if (Array.isArray(cleanQueryObj[key])) {
      cleanQueryObj[key] = cleanQueryObj[key].map((item: any) => item.toLowerCase().trim());
    }
  });
  // const {
  //   t0, t1, t2, tier0, tier1, tier2,
  // } = cleanQueryObj;

  // gtag("event", TRACKING_EVENT_NAME.CATEGORY_PAGE_VIEW, {
  //   send_to: GTAG_ID,
  //   id: `${tier0 || t0}|${tier1 || t1}|${tier2 || t2}`.toLowerCase(),
  //   item_title: capitalize(`${tier0 || t0} ${tier1 || t1} ${tier2 || t2}`),
  //   google_business_vertical: "custom",
  //   ...cleanQueryObj,
  // });
  trackEvents(
    eventName,
    "view",
    cleanQueryObj,
  );
}
